<template>
  <basic-card class="global-basic-card" padding hideHeader :hasMore="showMore">
    <avue-crud
      class="global-table"
      :option="optionParent"
      v-model:search="search"
      :table-loading="loading"
      :data="dataParent"
      :page="pageParent"
      ref="crud"
      v-model="formParent"
      :permission="permissionObj"
      :before-open="beforeOpen"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-click=""
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoadParent"
    >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
          <!-- <div class="global-flex-center">
            <comp-button
              type="primary"
              icon="icon-add"
              @click.stop="handleAdd()"
              v-if="permissionObj.add" 
              >{{ Lang.btn.addNew }}
            </comp-button>
            
            <comp-button
              type="normal"
              @click="toggleShowMore()"
              >{{ Lang.btn.more }}
            </comp-button>
          </div> -->
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            type="delete"
            v-if="permissionObj.delete" 
            plain
            @click="handleDelete"
            >{{ Lang.btn.delete }}
          </comp-button>
          <comp-button
              type="primary"
              icon="icon-add"
              @click.stop="handleAdd()"
              v-if="permissionObj.add" 
              >{{ Lang.btn.addNew }}
            </comp-button>
        </div>
      </template>
      <!-- 操作栏菜单 -->
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="edit" @click.stop="handleEdit(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="setting" icon="setting" @click.stop="handleRowClick(scope.row)" :text="$t('mBtn.dictConfig')" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click.stop="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>
      <template #i18ns-form="{ row }">
        <div class="global-i18n-fields">
          <el-form-item
            span="12"
            gutter="12"
            class="form-item"
            v-for="(item, i) in i18nOptoins"
            :label="Lang.label.name + ' ' + item.i18nLanguage"
            :prop="'i18ns.' + i + '.i18nValue'"
            :rules="item.i18nLanguage === 'en-US' ? [{ required: true, message: Lang.tips.plzInput + ' ' + item.i18nLanguage, trigger: 'blur' }] : []"
            labelPosition="top">
            <el-input
              class="el-input"
              v-model="formParent.i18ns[i].i18nValue"
              :placeholder="Lang.tips.plzInput + ' ' + item.i18nLanguage"
              :key="i"
              />
          </el-form-item>
        </div>
      </template>
      <template #code="{ row }">
        <el-tag @click.stop="copyToClipboard(row.code)" style="cursor: pointer">{{ row.code }}</el-tag>
      </template>
      <template #isSealed="{ row }">
        <el-tag>{{ row.isSealed === 0 ? Lang.label.no : Lang.label.yes }}</el-tag>
      </template>
    </avue-crud>
    <!-- 弹出框 -->
    <el-drawer :title="`[${dictValue}]${$t('mBtn.dictConfig')}`"
      append-to-body
      v-model="showChildBox"
      style="padding: 10px;"
      direction="rtl"
      size="90%"
      >
      <DictSub ref="dictSub" :parentId="parentId"></DictSub>
    </el-drawer>
  </basic-card>
</template>

<script>
import {
  getParentList,
  getChildList,
  remove,
  update,
  add,
  getDict,
  getDictTree,
} from '@/api/system/dict';
import { mapGetters } from 'vuex';
import { copyToClipboard } from '@/utils/util';
import { filterDollarKeys } from '@/utils/util';
import DictSub from './dict-sub.vue';
import { i18nOptoins, generateI18nOptoins } from '@/lang/lang';

export default {
  components: {
    DictSub
  },
  data() {
    return {
      tableKey: 0,
      i18nOptoins: i18nOptoins,
      dictValue: '暂无',
      parentId: -1,
      formParent: {
        i18ns: []
      },
      formChild: {},
      selectionList: [],
      query: {},
      search: {},
      showChildBox: false,
      loading: true,
      showMore: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0,
      },
      dataParent: [],
      optionParent: {
        // height: 'auto',
        maxHeight: 600, // 因为设计要求分页不要固定在底部 height: 'auto'
        calcHeight: 84,
        tip: false,
        
        // gutter: 12,
        border: false,
        index: true,
        selection: true,
        menuWidth: 116,
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        emptyBtn: false,
        searchBtn: false,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        searchShow: true,
        // dialogWidth: 880,
        dialogClickModal: false,
        searchMenuSpan: 8,
        searchMenuPosition: 'right',
        searchSpan: 4,
        searchGutter: 20,
        gutter: 20,
        searchLabelWidth: 'auto',
        searchLabelPosition: 'top',
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        dialogType: 'drawer', // dialog drawer
        dialogCustomClass: 'dialog-custom-class-sort',
        labelWidth: 'auto',
        labelPosition: 'top',
        searchLabelSuffix: ' ',
        column: [
          {
            label: this.$t('theader.dictionaryNumber'),
            prop: 'code',
            search: true,
            slot: true,
            span: 24,
            placeholder: this.Lang.tips.plzInput + ' ' + this.$t('theader.dictionaryNumber'),
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictNum,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.cnName,
            prop: 'dictValue',
            search: false,
            align: 'center',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputDictName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.enName,
            prop: 'enDictValue',
            search: false,
            align: 'center',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictEnName,
                trigger: 'blur',
              },
            ],
          },
          {
            prop: 'i18ns',
            search: false,
            slot: true,
            editDisplay: true,
            addDisplay: true,
            viewDisplay: true,
            hide: true,
            span: 24,
          },
          {
            label: this.Lang.Title.currentLanguageName,
            prop: 'i18nValue',
            search: true,
            align: 'center',
            placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.currentLanguageName,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictLocalName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.dictionarySorting'),
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictSort,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.archive'),
            prop: 'isSealed',
            type: 'switch',
            align: 'center',
            width: 100,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfSealedUp,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.dictRemark,
            prop: 'remark',
            hide: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj.setting = true; // test
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // this.initData();
  },
  methods: {
    initData() {
      // getDictTree().then(res => {
      //   const column = this.findObject(this.optionChild.column, 'parentId');
      //   column.dicData = res.data.data;
      // });
    },
    copyToClipboard(value) {
      copyToClipboard(value);
      this.$message({
        type: 'success',
        message: this.Lang.tips.hasBeenCopiedToClipboard,
      });
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.optionParent.selection = this.showMore;
      this.tableKey += 1;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search)
      const params = filterDollarKeys(this.search)
      this.onLoadParent(this.pageParent, params)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    rowSave(row, done, loading) {
      const form = {
        ...row,
        dictKey: -1,
      };
      add(form).then(
        () => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleRowClick(row) {
      this.query = {};
      this.parentId = row.id;
      this.dictValue = row.dictValue;

      // const code = this.findObject(this.optionChild.column, 'code');
      // code.value = row.code;
      // const parentId = this.findObject(this.optionChild.column, 'parentId');
      // parentId.value = row.id;

      // this.formChild.code = row.code;
      // this.formChild.parentId = row.id;

      this.showChildBox = true;
      this.$nextTick(() => {
        this.$refs.dictSub.initChild(row)
      })
      // this.onLoadChild(this.pageChild);
    },
    searchReset() {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange(params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoadParent(this.pageParent);
          // this.onLoadChild(this.pageChild);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDict(this.formParent.id).then(res => {
          this.formParent = res.data.data;
          if (!this.formParent.i18ns.length) {
            this.i18nOptoins = this.i18nOptoins.map(item => {
              return {
                i18nField: 'name',
                i18nLanguage: item.i18nLanguage,
                i18nValue:  '',
              };
            });
          } else {
            this.i18nOptoins = this.formParent.i18ns?.map(item => {
              return {
                i18nField: item.i18nField,
                i18nLanguage: item.i18nLanguage,
                i18nValue:  item.i18nValue || '',
              };
            });
          }
          this.formParent.i18ns = this.i18nOptoins;
        });
      }
      if (type === 'add') {
        const options = generateI18nOptoins();
        this.i18nOptoins = options.map(item => {
          return {
            i18nField: 'name',
            i18nLanguage: item.i18nLanguage,
            i18nValue: '',
          };
        });
        this.formParent.i18ns = this.i18nOptoins;
      }
      done();
    },
    currentChange(currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoadParent(this.pageParent, this.query);
    },
    onLoadParent(page, params = {}) {
      this.loading = true;
      getParentList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(
        res => {
          const data = res.data.data;
          this.pageParent.total = data.total;
          this.dataParent = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>
